import { environmentConfig } from "@src/appV2/environment";

export const SEND_CHECKR_APPLICATION_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/agentprofile/checkr/create-invitation`;
export const CHECKR_APPLICATION_STATUS_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/agentprofile/checkr/application-status`;
